export default class Problem {
	constructor(person, personCode, problem, problemCode) {
		this.person = {name: person, id: personCode}
		this.problem = {name: problem, id: problemCode}
	}
}